/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import useLendings from '@pages/lending/hooks/useLendings';
import { selectProfileData } from '@pages/profile/store/selectors';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import LendingTable from './LendingTable/LendingTable';
import PayLendingModal from './PayLendingModal/PayLendingModal';

const Lending = () => {
  const userProfile = useSelector(selectProfileData);
  const { data, loading, getLendingsService } = useLendings();

  const enterpriseId = useMemo(() => {
    if (userProfile?.company) return userProfile?.company?.enterpriseId;
    return null;
  }, [userProfile]);

  useEffect(() => {
    if (enterpriseId) {
      getLendingsService(enterpriseId);
    }
  }, [enterpriseId]);

  return (
    <>
      <LendingTable data={[]} loading={loading} />
      <PayLendingModal open={false} onCancel={() => {}} />
    </>
  );
};

export default Lending;
